import { CLEAR_UI, MERGE_UI, SET_UI, TOGGLE_UI, OCCLUDE_QUIZ_ENTRIES, ACTIVE_BANK_CHANGE, ACTIVE_BANK_ENTRY_CHANGE, LOADED_API_FEATURES } from '@instructure/quiz-common';
export var clear = function clear(key) {
  return {
    payload: key,
    type: CLEAR_UI
  };
};
export var toggle = function toggle(key) {
  return {
    payload: key,
    type: TOGGLE_UI
  };
};
export var set = function set(key, value) {
  return {
    payload: {
      key: key,
      value: value
    },
    type: SET_UI
  };
};
export var merge = function merge(key, value) {
  return {
    payload: {
      key: key,
      value: value
    },
    type: MERGE_UI
  };
};
export var occludeQuizEntries = function occludeQuizEntries(isOccluded) {
  return {
    type: OCCLUDE_QUIZ_ENTRIES,
    payload: isOccluded
  };
};
export var newActiveBank = function newActiveBank(activeBankId) {
  return {
    type: ACTIVE_BANK_CHANGE,
    payload: activeBankId
  };
};
export var newActiveBankEntry = function newActiveBankEntry(activeBankEntryId) {
  return {
    type: ACTIVE_BANK_ENTRY_CHANGE,
    payload: activeBankEntryId
  };
};
export var loadedApiFeatures = function loadedApiFeatures(loaded) {
  return {
    type: LOADED_API_FEATURES,
    payload: loaded
  };
};
export var setActiveCalculatorId = function setActiveCalculatorId(id) {
  return set('activeCalculatorId', id);
};